(() => {
  const root = document.querySelector('[data-tps]');
  if (!root) return;
  const cfgEl = document.querySelector('[data-tps-config]');
  let CFG = {};
  try { CFG = JSON.parse(cfgEl.textContent); } catch (e) { console.error('[tps] config', e); }

  /* ---------- helpers ---------- */
  const $ = s => root.querySelector(s);
  const $$ = s => [...root.querySelectorAll(s)];
  const uid = () => Math.random().toString(36).slice(2, 9);
  const clamp = (v, a, b) => Math.min(b, Math.max(a, v));
  const clean = v => String(v || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
  const money = cents => new Intl.NumberFormat(undefined, { style: 'currency', currency: CFG.currency || 'USD' }).format((Number(cents) || 0) / 100);
  const esc = s => String(s ?? '').replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const toast = (msg, ms = 2600) => { const t = $('[data-toast]'); t.textContent = msg; t.hidden = false; clearTimeout(toast.t); toast.t = setTimeout(() => t.hidden = true, ms); };

  const FONTS = [
    ['Anton', 'Anton', 400], ['Bebas Neue', 'Bebas Neue', 400], ['Oswald', 'Oswald', 600], ['Graduate (Varsity)', 'Graduate', 400],
    ['Alfa Slab One', 'Alfa Slab One', 400], ['Roboto Slab', 'Roboto Slab', 800], ['Montserrat', 'Montserrat', 800],
    ['Permanent Marker', 'Permanent Marker', 400], ['Pacifico (Script)', 'Pacifico', 400], ['Lobster', 'Lobster', 400], ['Arial Black', 'Arial Black', 900], ['Georgia', 'Georgia', 700]
  ];
  const fontWeight = f => (FONTS.find(x => x[1] === f) || [0, 0, 700])[2];
  const fontOptions = sel => { sel.innerHTML = FONTS.map(([label, fam]) => `<option value="${esc(fam)}" style="font-family:'${esc(fam)}'">${esc(label)}</option>`).join(''); };

  const TIERS = [[1, 5, '1-5'], [6, 11, '6-11'], [12, 23, '12-23'], [24, 47, '24-47'], [48, Infinity, '48+']];
  const tierFor = n => (TIERS.find(t => n >= t[0] && n <= t[1]) || TIERS[0]);
  const charge = title => (CFG.charges || {})[title] || null;
  const chargePrice = title => charge(title)?.price || 0;
  const hasCharges = () => !!charge('Front print 1-5');
  /* a back print on a shirt that also has a front print is billed at the lower "Second side" rate */
  const backTitle = tier => (S.layers.Front.length && charge('Second side ' + tier)) ? 'Second side ' + tier : 'Back print ' + tier;

  const SIZE_ORDER = ['XS', 'S', 'M', 'L', 'XL', '2XL', '3XL', '4XL', '5XL', '6XL'];
  const sizeSort = (a, b) => (SIZE_ORDER.indexOf(a) + 1 || 99) - (SIZE_ORDER.indexOf(b) + 1 || 99);

  const PALETTE = { black: '#111111', white: '#ffffff', natural: '#e8dfca', 'off white': '#f3efe4', navy: '#172d50', royal: '#2457a7', purple: '#633b8c', maroon: '#6f2038', red: '#c52634', cardinal: '#9e2131', cherry: '#b42535', garnet: '#7b1f2c', pink: '#eca0ba', azalea: '#e86a9d', heliconia: '#db377a', orange: '#ed7624', tangerine: '#f28b3a', gold: '#d2a62d', yellow: '#f0d238', daisy: '#f5dc45', cornsilk: '#f2e7a8', green: '#258245', forest: '#244b3c', kelly: '#168b4b', irish: '#2ca968', military: '#5e6848', sage: '#9ba98d', mint: '#a8d8bf', blue: '#3977b9', sapphire: '#2076a8', carolina: '#8bb8dc', sky: '#8fd0ea', aqua: '#55b7bf', turquoise: '#3aaabd', indigo: '#3f5974', charcoal: '#4f5358', graphite: '#696d71', 'dark heather': '#4b4e53', 'sport grey': '#a7a9ac', grey: '#9a9c9f', gray: '#9a9c9f', ash: '#d7d8d8', 'ice grey': '#c9cdd0', sand: '#cbb994', 'prairie dust': '#a79a7b', khaki: '#b9a67b', brown: '#674737', chocolate: '#4c3329', russet: '#6a3b2c', coral: '#ec8376', berry: '#93475e', lavender: '#b49ccc', lilac: '#b89fc9', violet: '#8b78b8', orchid: '#b06da1', lime: '#91bd42', kiwi: '#8da850', cream: '#eee5cd', safety: '#d7ff3a', neon: '#39ff88', midnight: '#1d2a3a', iris: '#5b6fb7', cobalt: '#27418f', 'light blue': '#b5d3ea', 'light pink': '#f3c4d3', tweed: '#6c6a66', gravel: '#8d8c8a', sunset: '#f07a55', 'dusty rose': '#c98f93', 'blue dusk': '#43546b', 'yellow haze': '#f2e59a', 'electric green': '#3fc16b', 'texas orange': '#b65a1f', 'tennessee orange': '#e7862b' };
  const colorHex = name => { const v = clean(name); const keys = Object.keys(PALETTE).sort((a, b) => b.length - a.length); for (const k of keys) if (v.includes(k)) return PALETTE[k]; let h = 0; for (const c of v) h = (h * 31 + c.charCodeAt(0)) >>> 0; return `hsl(${h % 360} 40% 50%)`; };

  /* S&S Activewear flat-lay color IDs (front: _f_fl, back: _b_fl) */
  const SS = {'ss-gildan-5000':{'white':16813,'black':16787,'antique cherry red':33476,'antique irish green':33477,'antique jade dome':33496,'antique orange':33499,'antique sapphire':33483,'aquatic':114510,'ash':16785,'azalea':16786,'berry':33485,'blackberry':33481,'blue dusk':114522,'brown savana':33488,'cardinal':16788,'carolina blue':16789,'charcoal':16790,'cobalt':40523,'coral silk':33479,'cornsilk':42437,'daisy':16791,'dark chocolate':30025,'dark heather':40520,'dusty rose':114512,'electric green':37317,'fan dark green':137508,'fan dark purple':137509,'fan deep royal':137510,'fan marine green':137512,'forest green':16793,'garnet':32126,'gold':30026,'graphite heather':46045,'gravel':33486,'heather military green':33475,'heather navy':68108,'heather neon coral':107672,'heather radiant orchid':52325,'heather red':33487,'heather sapphire':33474,'heliconia':32127,'ice grey':37312,'indigo blue':16795,'iris':107675,'irish green':30027,'jade dome':137507,'kiwi':30028,'light blue':16798,'light pink':30029,'lilac':37313,'lime':30030,'maroon':27238,'midnight':37314,'military green':30031,'mint green':40519,'natural':16802,'navy':16803,'neon blue':42440,'neon green':42441,'off white':114519,'old gold':32128,'orange':16804,'prairie dust':107673,'purple':30032,'red':27239,'royal':16806,'russet':33482,'safety green':40521,'safety orange':40522,'safety pink':42438,'sand':16807,'sapphire':16808,'sky':16809,'sport grey':16810,'sunset':37315,'tangerine':16811,'tennessee orange':32129,'texas orange':42439,'tropical blue':37316,'turf green':33495,'tweed':33480,'violet':16812,'yellow haze':16814},'ss-gildan-8000':{'white':17927,'black':17904,'ash':17902,'azalea':17903,'carolina blue':17905,'daisy':17906,'dark green':66717,'dark heather':32135,'dark maroon':66709,'dark navy':66707,'deep royal':66711,'electric green':37322,'forest green':17908,'gold':17909,'graphite heather':46133,'gravel':66719,'heather dark navy':66721,'heather deep royal':66724,'heather scarlet red':66725,'heliconia':17910,'irish green':29849,'jade dome':17912,'kelly':27413,'light blue':17913,'light pink':17914,'lime':17915,'maroon':27414,'navy':17917,'orange':17918,'orchid':17919,'purple':17920,'red':27415,'royal':17921,'safety green':66716,'safety orange':66703,'sand':17922,'sapphire':17923,'scarlet red':66704,'sport grey':17924,'tennessee orange':32137,'texas orange':17926},'ss-gildan-64000':{'white':29885,'black':29881,'antique cherry red':33310,'antique heliconia':37318,'antique sapphire':33309,'azalea':52348,'cardinal red':16924,'carolina blue':52352,'charcoal':16925,'cherry red':16926,'coral silk':52359,'cornsilk':42447,'daisy':52360,'dark chocolate':29866,'dark heather':32215,'desert clay':141984,'fan candy pink':137555,'fan dark green':137556,'fan dark purple':137558,'fan deep royal':137559,'fan marine green':137560,'fan texas orange':137561,'forest':29882,'garnet':137562,'gold':78863,'graphite heather':52363,'heather berry':68150,'heather cardinal red':52364,'heather dark grey':108795,'heather galapagos blue':68154,'heather heliconia':68155,'heather indigo':52365,'heather irish green':32217,'heather maroon':32218,'heather military green':33312,'heather navy':32216,'heather oatmeal':137563,'heather orange':33316,'heather purple':33317,'heather radiant orchid':68148,'heather red':46143,'heather royal':32219,'heather sapphire':52367,'heliconia':98962,'ice grey':78849,'indigo blue':16930,'iris':52371,'irish green':29867,'jade dome':52372,'kelly green':78846,'kiwi':16931,'light blue':16932,'light pink':104272,'lime':52374,'maroon':29868,'metro blue':52383,'military green':16933,'mint green':52385,'natural':52386,'navy':29883,'neon blue':137564,'off white':107628,'orange':16935,'paragon':107622,'pistachio':107630,'prairie dust':141985,'purple':37320,'red':29869,'royal':29870,'sage':104276,'sand':16937,'sapphire':46140,'sky':104275,'sport grey':29884,'stone blue':104279,'tropical blue':52388,'turf green':137565}};
  /* extra S&S color IDs and per-garment print areas come from the "Studio variant loader" section */
  Object.entries(window.TPS_SS || {}).forEach(([h, m]) => { SS[h] = Object.assign(SS[h] || {}, Object.fromEntries(Object.entries(m).map(([k, v]) => [clean(k), v]))); });
  /* print area on the flat-lay image, % of the square board: [left, top, width, height] ~ 12" x 14" */
  const AREA = { Front: [35, 25, 30, 36], Back: [35, 21, 30, 40] };
  const AREA_IN = { Front: [12, 14], Back: [12, 14] };
  const DEF_AREA = JSON.parse(JSON.stringify(AREA)), DEF_IN = JSON.parse(JSON.stringify(AREA_IN));
  const applyArea = h => { const o = (window.TPS_AREA || {})[h] || {}; ['Front', 'Back'].forEach(side => { AREA[side] = (o[side] && o[side].box) || DEF_AREA[side]; AREA_IN[side] = (o[side] && o[side].in) || DEF_IN[side]; }); };
  const garmentUrl = (handle, color, side) => {
    const id = SS[handle] && SS[handle][clean(color)];
    return id ? `https://cdn.ssactivewear.com/Images/Color/${id}_${side === 'Back' ? 'b' : 'f'}_fl.jpg` : null;
  };

  /* ---------- state ---------- */
  const S = {
    step: 1, side: 'Front', tool: 'products', sel: null, zoom: false,
    product: null, productData: null, colors: [], color: null,
    layers: { Front: [], Back: [] },
    qty: {},              // qty[color][size] = n
    nn: { name: false, number: false, font: 'Graduate', color: '#111111' },
    roster: [],           // {id,name,number,color,size}
    files: {}             // layerId -> File (uploads, not serializable)
  };
  const hist = { past: [], future: [] };
  const snapshot = () => JSON.stringify({ layers: S.layers, nn: S.nn });
  let lastSnap = null;
  const commit = () => {
    const snap = snapshot();
    if (snap === lastSnap) return;
    if (lastSnap !== null) hist.past.push(lastSnap);
    if (hist.past.length > 60) hist.past.shift();
    hist.future = [];
    lastSnap = snap;
    syncUndo(); autosave(); updateLive();
  };
  const restore = snap => { const o = JSON.parse(snap); S.layers = o.layers; S.nn = o.nn; lastSnap = snap; S.sel = null; renderAll(); autosave(); updateLive(); };
  const syncUndo = () => { $('[data-undo]').disabled = !hist.past.length; $('[data-redo]').disabled = !hist.future.length; };

  /* ---------- DOM refs ---------- */
  const board = $('[data-board]'), zone = $('[data-zone]'), garment = $('[data-garment]');

  /* ---------- products & colors ---------- */
  const products = CFG.products || [];
  /* product cards: grouped into drop-downs and shown in a color (window.TPS_CARDS from the loader section) */
  const CARDS = window.TPS_CARDS || {};
  const GROUP_ORDER = ['T-Shirts', 'Long Sleeve', 'Hoodies & Sweatshirts', 'Tank Tops', 'Youth & Toddler'];
  const openGroups = new Set();
  const cardImg = p => garmentUrl(p.handle, (CARDS[p.handle] || {}).color || '', 'Front') || p.image;
  const prodCard = p => `
      <button type="button" class="tps-prod${p.handle === S.product ? ' is-on' : ''}" data-prod="${esc(p.handle)}">
        <img src="${esc(cardImg(p))}" alt="" width="62" height="62" loading="lazy">
        <span><strong>${esc(p.label)}</strong><small>${esc(p.blurb || '')}</small><b>Blank from ${money(p.from)}</b></span>
      </button>`;
  const renderProducts = () => {
    const groups = {};
    products.forEach(p => { const g = (CARDS[p.handle] || {}).group || 'More styles'; (groups[g] = groups[g] || []).push(p); });
    const names = [...GROUP_ORDER.filter(g => groups[g]), ...Object.keys(groups).filter(g => !GROUP_ORDER.includes(g))];
    if (names.length < 2) { $('[data-products]').innerHTML = products.map(prodCard).join(''); }
    else {
      if (S.product) openGroups.add((CARDS[S.product] || {}).group || 'More styles');
      $('[data-products]').innerHTML = names.map(g => `<details class="tps-group" data-group="${esc(g)}"${openGroups.has(g) ? ' open' : ''}><summary><img src="${esc(cardImg(groups[g][0]))}" alt="" loading="lazy"><span><strong>${esc(g)}</strong><small>${groups[g].length} style${groups[g].length === 1 ? '' : 's'} · blanks from ${money(Math.min(...groups[g].map(p => p.from)))}</small></span></summary><div class="tps-group-list">${groups[g].map(prodCard).join('')}</div></details>`).join('');
      $$('[data-group]').forEach(d => d.addEventListener('toggle', () => { if (d.open) openGroups.add(d.dataset.group); else openGroups.delete(d.dataset.group); }));
    }
    $$('[data-prod]').forEach(b => b.addEventListener('click', () => selectProduct(b.dataset.prod)));
  };
  const optIndex = name => (S.productData?.options || []).findIndex(o => clean(typeof o === 'string' ? o : o.name).includes(name));
  const colorsOf = () => { const i = optIndex('color'); if (i < 0) return []; const o = S.productData.options[i]; return (typeof o === 'string' ? [...new Set(S.productData.variants.map(v => v.options[i]))] : o.values); };
  const sizesOf = () => { const i = optIndex('size'); if (i < 0) return ['One size']; const o = S.productData.options[i]; return [...(typeof o === 'string' ? new Set(S.productData.variants.map(v => v.options[i])) : o.values)].sort(sizeSort); };
  const variantFor = (color, size) => {
    const ci = optIndex('color'), si = optIndex('size');
    return (S.productData?.variants || []).find(v => (ci < 0 || v.options[ci] === color) && (si < 0 || v.options[si] === size));
  };
  const selectProduct = async (handle, keepColors) => {
    S.product = handle;
    applyArea(handle);
    renderProducts();
    $('[data-swatches]').innerHTML = '<p class="tps-muted">Loading colors…</p>';
    try {
      const r = await fetch(`/products/${encodeURIComponent(handle)}.js`);
      S.productData = r.ok ? await r.json() : null;
    } catch (e) { S.productData = null; }
    if (!S.productData) { $('[data-swatches]').innerHTML = '<p class="tps-muted">This shirt could not load. Please try another.</p>'; return; }
    const all = colorsOf();
    const wanted = (keepColors || []).filter(c => all.includes(c));
    S.colors = wanted.length ? wanted : [all.find(c => clean(c) === 'white') || all[0]];
    S.color = S.colors[0];
    // drop quantities for colors no longer valid
    Object.keys(S.qty).forEach(c => { if (!S.colors.includes(c)) delete S.qty[c]; });
    /* Oct 2026 fix: roster rows could keep a color from a previous style or saved design. The roster drop-down then
       showed the first color (e.g. White) while the order was built with the stale one (e.g. Fan Dark Green). */
    S.roster.forEach(r => { if (!S.colors.includes(r.color)) r.color = S.color; });
    renderColors(); renderGarment(); updateLive(); autosave();
  };
  const renderColors = () => {
    const all = colorsOf();
    $('[data-swatches]').innerHTML = all.map(c => `<button type="button" class="tps-sw${S.colors.includes(c) ? ' is-in' : ''}" style="background:${colorHex(c)}" title="${esc(c)}" data-sw="${esc(c)}"></button>`).join('');
    $$('[data-sw]').forEach(b => b.addEventListener('click', () => {
      const c = b.dataset.sw;
      if (!S.colors.includes(c)) S.colors.push(c);
      S.color = c; renderColors(); renderGarment(); autosave(); updateLive();
    }));
    $('[data-chosen]').innerHTML = S.colors.map(c => `<span class="tps-chip${c === S.color ? ' is-on' : ''}"><button type="button" data-pick="${esc(c)}" style="display:flex;align-items:center;gap:6px;padding:0"><i style="background:${colorHex(c)}"></i>${esc(c)}</button>${S.colors.length > 1 ? `<button type="button" data-unpick="${esc(c)}" aria-label="Remove ${esc(c)}">×</button>` : ''}</span>`).join('');
    $('[data-color-count]').textContent = `${S.colors.length} color${S.colors.length === 1 ? '' : 's'}`;
    $$('[data-pick]').forEach(b => b.addEventListener('click', () => { S.color = b.dataset.pick; renderColors(); renderGarment(); }));
    $$('[data-unpick]').forEach(b => b.addEventListener('click', () => { const c = b.dataset.unpick; S.colors = S.colors.filter(x => x !== c); delete S.qty[c]; S.roster.forEach(r => { if (r.color === c) r.color = S.colors[0]; }); if (S.color === c) S.color = S.colors[0]; renderColors(); renderGarment(); autosave(); updateLive(); }));
  };
  const renderGarment = () => {
    const p = products.find(x => x.handle === S.product);
    const url = garmentUrl(S.product, S.color, S.side) || (S.side === 'Front' ? p?.image : null) || p?.image;
    if (url && garment.getAttribute('src') !== url) garment.src = url;
    const a = AREA[S.side];
    Object.assign(zone.style, { left: a[0] + '%', top: a[1] + '%', width: a[2] + '%', height: a[3] + '%' });
    $('[data-zone-label]').textContent = `${S.side} print area · ${AREA_IN[S.side][0]}" × ${AREA_IN[S.side][1]}"`;
    $$('[data-view]').forEach(b => b.classList.toggle('is-on', b.dataset.view === S.side));
    const cf = S.layers.Front.length ? 'front' : '', cb = (S.layers.Back.length || S.nn.name || S.nn.number) ? 'back' : '';
    $('[data-caption]').textContent = `${p?.label || ''} · ${S.color || ''}${cf || cb ? ' · printing ' + [cf, cb].filter(Boolean).join(' + ') : ''}`;
    renderLayers(); renderThumbs();
  };

  /* ---------- layers ---------- */
  const layersOn = side => S.layers[side];
  const findLayer = id => { for (const side of ['Front', 'Back']) { const l = S.layers[side].find(x => x.id === id); if (l) return [l, side]; } return [null, null]; };
  const measure = document.createElement('canvas').getContext('2d');
  const textMetrics = l => {
    const lines = String(l.text || ' ').split('\n');
    measure.font = `${fontWeight(l.font)} 100px "${l.font}"`;
    const wide = Math.max(...lines.map(t => measure.measureText(t || ' ').width), 1);
    return { lines, wide, lh: 118 };
  };
  const textSVG = (l, pxWidth) => {
    const { lines, wide, lh } = textMetrics(l);
    const fs = 100, pad = (l.strokeW || 0) * 2 + 4;
    const arc = Number(l.arc || 0);
    const W = wide + pad * 2;
    const H = lines.length * lh + pad * 2 + Math.abs(arc) * (lines.length === 1 ? 1.2 : 0);
    const stroke = l.strokeW ? `stroke="${esc(l.stroke)}" stroke-width="${l.strokeW * 2}" paint-order="stroke" stroke-linejoin="round"` : '';
    const style = `font-family:'${esc(l.font)}';font-weight:${fontWeight(l.font)};font-size:${fs}px`;
    let body;
    if (arc && lines.length === 1) {
      const r = (wide * 100) / (Math.abs(arc) * 3.2) + wide / 2; // bigger arc value -> smaller radius
      const cx = W / 2, sag = r - Math.sqrt(Math.max(r * r - (wide / 2) ** 2, 0));
      const up = arc > 0; // positive arcs curve upward (rainbow)
      const baseY = up ? pad + fs * 0.85 + sag : pad + fs * 0.85;
      const pid = 'p' + l.id;
      const d = up ? `M ${cx - wide / 2 - 20} ${baseY} A ${r} ${r} 0 0 1 ${cx + wide / 2 + 20} ${baseY}` : `M ${cx - wide / 2 - 20} ${baseY} A ${r} ${r} 0 0 0 ${cx + wide / 2 + 20} ${baseY}`;
      body = `<defs><path id="${pid}" d="${d}"/></defs><text style="${style}" fill="${esc(l.color)}" ${stroke}><textPath href="#${pid}" startOffset="50%" text-anchor="middle">${esc(lines[0])}</textPath></text>`;
    } else {
      body = lines.map((t, i) => `<text x="${W / 2}" y="${pad + fs * 0.85 + i * lh}" text-anchor="middle" style="${style}" fill="${esc(l.color)}" ${stroke}>${esc(t)}</text>`).join('');
    }
    return { svg: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${W} ${H}" width="${pxWidth}" height="${pxWidth * H / W}">${body}</svg>`, ratio: H / W };
  };
  const nnText = kind => {
    const row = S.roster.find(r => kind === 'name' ? r.name : r.number);
    return kind === 'name' ? (row?.name || 'NAME').toUpperCase() : (row?.number || '00');
  };
  const layerHTML = (l, zoneW) => {
    const px = zoneW * l.w / 100;
    if (l.type === 'image') return `<img src="${esc(l.handle ? cutout(l.src) : l.src)}" alt="">`;
    const t = l.type === 'nn-name' ? { ...l, text: nnText('name'), font: S.nn.font, color: S.nn.color } : l.type === 'nn-number' ? { ...l, text: nnText('number'), font: S.nn.font, color: S.nn.color } : l;
    return textSVG(t, px).svg;
  };
  const renderLayers = () => {
    zone.querySelectorAll('.tps-layer').forEach(n => n.remove());
    const zw = zone.getBoundingClientRect().width || 200;
    const list = layersOn(S.side).filter(l => (l.type !== 'nn-name' || S.nn.name) && (l.type !== 'nn-number' || S.nn.number));
    list.forEach(l => {
      const el = document.createElement('div');
      el.className = 'tps-layer' + (l.id === S.sel ? ' is-sel' : '');
      el.dataset.layer = l.id;
      el.style.left = l.x + '%'; el.style.top = l.y + '%'; el.style.width = l.w + '%';
      el.style.transform = `translate(-50%,-50%) rotate(${l.rot || 0}deg) scaleX(${l.flip ? -1 : 1})`;
      el.innerHTML = layerHTML(l, zw);
      if (l.id === S.sel) el.insertAdjacentHTML('beforeend', `<span class="tps-h tps-h-rot" data-h="rot">⟳</span><span class="tps-h tps-h-size" data-h="size">⤡</span>${l.type.startsWith('nn') ? '' : '<span class="tps-h tps-h-del" data-h="del">×</span>'}`);
      zone.appendChild(el);
    });
    zone.classList.toggle('is-active', list.length > 0);
    const empty = list.length === 0;
    $('[data-empty-cta]').hidden = !empty;
    $$('[data-back-only]').forEach(b => b.hidden = S.side !== 'Back');
    renderThumbs();
  };
  const addLayer = (l, side = S.side) => {
    const base = { id: uid(), x: 50, y: 42, w: 60, rot: 0, flip: false };
    const layer = { ...base, ...l };
    S.layers[side].push(layer);
    if (side !== S.side) setSide(side);
    select(layer.id);
    renderGarment(); commit();
    return layer;
  };
  const select = id => {
    S.sel = id;
    renderLayers();
    if (id) openEditor(); else if (S.tool === 'edit') setTool('products');
  };

  /* ---------- pointer interactions ---------- */
  let drag = null;
  zone.addEventListener('pointerdown', e => {
    const h = e.target.closest('[data-h]');
    const el = e.target.closest('[data-layer]');
    if (!el) { select(null); return; }
    const [l] = findLayer(el.dataset.layer);
    if (!l) return;
    if (h?.dataset.h === 'del') { removeLayer(l.id); return; }
    if (S.sel !== l.id) select(l.id);
    const zr = zone.getBoundingClientRect();
    const cx = zr.left + zr.width * l.x / 100, cy = zr.top + zr.height * l.y / 100;
    drag = { mode: h?.dataset.h || 'move', id: l.id, sx: e.clientX, sy: e.clientY, ox: l.x, oy: l.y, ow: l.w, orot: l.rot || 0, zr, cx, cy,
      d0: Math.hypot(e.clientX - cx, e.clientY - cy) || 1, a0: Math.atan2(e.clientY - cy, e.clientX - cx) };
    zone.setPointerCapture(e.pointerId);
    e.preventDefault();
  });
  zone.addEventListener('pointermove', e => {
    if (!drag) return;
    const [l] = findLayer(drag.id); if (!l) return;
    if (drag.mode === 'move') {
      l.x = clamp(drag.ox + (e.clientX - drag.sx) / drag.zr.width * 100, 0, 100);
      l.y = clamp(drag.oy + (e.clientY - drag.sy) / drag.zr.height * 100, 0, 100);
      if (Math.abs(l.x - 50) < 1.5) l.x = 50; // snap to center line
    } else if (drag.mode === 'size') {
      const d = Math.hypot(e.clientX - drag.cx, e.clientY - drag.cy);
      l.w = clamp(drag.ow * d / drag.d0, 4, 110);
    } else if (drag.mode === 'rot') {
      const a = Math.atan2(e.clientY - drag.cy, e.clientX - drag.cx);
      let deg = drag.orot + (a - drag.a0) * 180 / Math.PI;
      deg = ((deg + 540) % 360) - 180;
      if (Math.abs(deg) < 3) deg = 0;
      l.rot = Math.round(deg);
    }
    const el = zone.querySelector(`[data-layer="${l.id}"]`);
    if (el) {
      el.style.left = l.x + '%'; el.style.top = l.y + '%'; el.style.width = l.w + '%';
      el.style.transform = `translate(-50%,-50%) rotate(${l.rot || 0}deg) scaleX(${l.flip ? -1 : 1})`;
    }
  });
  const endDrag = () => { if (!drag) return; drag = null; renderLayers(); syncEditor(); commit(); };
  zone.addEventListener('pointerup', endDrag);
  zone.addEventListener('pointercancel', endDrag);
  board.addEventListener('pointerdown', e => { if (!e.target.closest('[data-zone]') && !e.target.closest('[data-empty-cta]')) select(null); });

  const removeLayer = id => {
    const [l, side] = findLayer(id); if (!l) return;
    if (l.type.startsWith('nn')) return;
    S.layers[side] = S.layers[side].filter(x => x.id !== id);
    delete S.files[id];
    if (S.sel === id) S.sel = null;
    if (S.tool === 'edit') setTool('products');
    renderGarment(); commit();
  };
  document.addEventListener('keydown', e => {
    if (!S.sel || S.step !== 1) return;
    if (/input|textarea|select/i.test(document.activeElement?.tagName)) return;
    const [l] = findLayer(S.sel); if (!l) return;
    const n = e.shiftKey ? 5 : 1;
    if (e.key === 'Delete' || e.key === 'Backspace') { removeLayer(S.sel); e.preventDefault(); }
    else if (e.key === 'ArrowLeft') { l.x -= n * .5; } else if (e.key === 'ArrowRight') { l.x += n * .5; }
    else if (e.key === 'ArrowUp') { l.y -= n * .5; } else if (e.key === 'ArrowDown') { l.y += n * .5; } else return;
    e.preventDefault(); renderLayers(); commit();
  });

  /* ---------- tools / panels ---------- */
  const setTool = tool => {
    S.tool = tool;
    $$('[data-tool]').forEach(b => b.classList.toggle('is-on', b.dataset.tool === tool));
    $$('[data-pane]').forEach(p => { p.hidden = p.dataset.pane !== tool; p.classList.toggle('is-on', p.dataset.pane === tool); });
    if (tool === 'names' && S.side !== 'Back') setSide('Back');
  };
  $$('[data-tool]').forEach(b => b.addEventListener('click', () => { if (S.step !== 1) goStep(1); select(null); setTool(b.dataset.tool); }));
  $$('[data-go]').forEach(b => b.addEventListener('click', () => { setTool(b.dataset.go); if (b.dataset.go === 'upload') $('[data-upload]').click(); if (b.dataset.go === 'text') $('[data-new-text]').focus(); }));
  const setSide = side => { S.side = side; S.sel = null; renderGarment(); if (S.tool === 'edit') setTool('products'); };
  $$('[data-view]').forEach(b => b.addEventListener('click', () => setSide(b.dataset.view)));
  $('[data-zoom]').addEventListener('click', () => { S.zoom = !S.zoom; board.classList.toggle('is-zoomed', S.zoom); });

  /* text */
  $('[data-add-text]').addEventListener('click', () => {
    const t = $('[data-new-text]').value.trim();
    if (!t) { $('[data-new-text]').focus(); return; }
    addLayer({ type: 'text', text: t, font: 'Anton', color: /black|navy|charcoal|dark|forest|maroon|midnight|chocolate|garnet|purple|royal|graphite|cardinal/i.test(S.color || '') ? '#ffffff' : '#111111', stroke: '#ffffff', strokeW: 0, arc: 0, w: Math.min(80, 16 + t.length * 5) });
    $('[data-new-text]').value = '';
  });

  /* uploads */
  const readImage = file => new Promise((res, rej) => {
    if (!/^image\//.test(file.type)) return rej(new Error('Please choose an image file.'));
    if (file.size > 20 * 1024 * 1024) return rej(new Error('That file is over 20 MB.'));
    const url = URL.createObjectURL(file);
    const img = new Image();
    img.onload = () => res({ url, w: img.naturalWidth || 1000, h: img.naturalHeight || 1000 });
    img.onerror = () => rej(new Error('That image could not be read.'));
    img.src = url;
  });
  const addFiles = async files => {
    for (const file of files) {
      try {
        const { url, w, h } = await readImage(file);
        const layer = addLayer({ type: 'image', src: url, name: file.name, natW: w, natH: h, w: 70, upload: true });
        S.files[layer.id] = file;
        const dpi = dpiFor(layer);
        if (dpi < 150) toast(`Heads up: "${file.name}" is low resolution (${dpi} DPI at this size). It may print blurry.`, 5000);
      } catch (e) { toast(e.message); }
    }
  };
  $('[data-upload]').addEventListener('change', e => { addFiles([...e.target.files]); e.target.value = ''; });
  ['dragenter', 'dragover'].forEach(ev => window.addEventListener(ev, e => { if (S.step === 1 && [...(e.dataTransfer?.types || [])].includes('Files')) { e.preventDefault(); root.classList.add('is-dragging'); } }));
  ['dragleave', 'drop'].forEach(ev => window.addEventListener(ev, e => { if (ev === 'dragleave' && e.relatedTarget) return; root.classList.remove('is-dragging'); }));
  window.addEventListener('drop', e => { if (S.step !== 1 || !e.dataTransfer?.files?.length) return; e.preventDefault(); addFiles([...e.dataTransfer.files]); });
  window.addEventListener('paste', e => {
    if (S.step !== 1 || /input|textarea/i.test(document.activeElement?.tagName)) return;
    const files = [...(e.clipboardData?.items || [])].filter(i => i.kind === 'file').map(i => i.getAsFile()).filter(Boolean);
    if (files.length) { e.preventDefault(); addFiles(files); }
  });
  const dpiFor = l => {
    if (!l.natW) return 300;
    const inches = AREA_IN[findLayer(l.id)[1] || S.side][0] * l.w / 100;
    return Math.round(l.natW / Math.max(inches, .1));
  };

  /* library */
  const addLibrary = (src, name, handle) => {
    const img = new Image(); img.crossOrigin = 'anonymous';
    img.onload = () => addLayer({ type: 'image', src, name, handle, natW: img.naturalWidth, natH: img.naturalHeight, w: 72 });
    img.onerror = () => addLayer({ type: 'image', src, name, handle, w: 72 });
    img.src = src;
  };
  /* ready-made design photos often have a white background: flood-fill it away from the edges
     so the art sits on the shirt (and in the print file) like a real transfer */
  const cutDone = {}, cutP = {};
  const makeCutout = async src => {
    try {
      const img = await loadImg(src);
      const s = Math.min(1, 1400 / Math.max(img.naturalWidth, img.naturalHeight));
      const W = Math.round(img.naturalWidth * s), H = Math.round(img.naturalHeight * s);
      const c = document.createElement('canvas'); c.width = W; c.height = H;
      const x = c.getContext('2d'); x.drawImage(img, 0, 0, W, H);
      const d = x.getImageData(0, 0, W, H), p = d.data;
      const bgAt = i => p[i + 3] < 16 || (p[i] > 232 && p[i + 1] > 232 && p[i + 2] > 232);
      const corners = [0, (W - 1) * 4, (H - 1) * W * 4, ((H - 1) * W + W - 1) * 4];
      if (corners.every(i => p[i + 3] < 16) || !corners.some(bgAt)) return null;
      const seen = new Uint8Array(W * H), st = [];
      const push = k => { if (!seen[k] && bgAt(k * 4)) { seen[k] = 1; st.push(k); } };
      for (let a = 0; a < W; a++) { push(a); push((H - 1) * W + a); }
      for (let b = 0; b < H; b++) { push(b * W); push(b * W + W - 1); }
      while (st.length) { const k = st.pop(), a = k % W, b = (k - a) / W; if (a > 0) push(k - 1); if (a < W - 1) push(k + 1); if (b > 0) push(k - W); if (b < H - 1) push(k + W); }
      for (let k = 0; k < W * H; k++) {
        if (seen[k]) { p[k * 4 + 3] = 0; continue; }
        const a = k % W, edge = (a > 0 && seen[k - 1]) || (a < W - 1 && seen[k + 1]) || (k >= W && seen[k - W]) || (k < W * H - W && seen[k + W]);
        if (edge) { const m = Math.min(p[k * 4], p[k * 4 + 1], p[k * 4 + 2]); if (m > 180) p[k * 4 + 3] = Math.round(p[k * 4 + 3] * Math.min(1, (255 - m) / 75)); }
      }
      x.putImageData(d, 0, 0);
      return c.toDataURL('image/png');
    } catch (e) { return null; }
  };
  const cutFor = src => cutP[src] || (cutP[src] = makeCutout(src).then(u => { cutDone[src] = u || src; if (u) renderLayers(); return cutDone[src]; }));
  const cutout = src => { if (cutDone[src]) return cutDone[src]; cutFor(src); return src; };
  /* library: the section only renders the first 60 designs, so searching loads the whole
     collection (title, tags and type) from /collections/<handle>/products.json */
  const lib = $('[data-library]');
  lib?.addEventListener('click', e => { const b = e.target.closest('[data-lib]'); if (b) addLibrary(b.dataset.src, b.dataset.name, b.dataset.handle); });
  const firstLib = lib ? lib.innerHTML : '';
  let allDesigns = null;
  const loadDesigns = () => allDesigns || (allDesigns = (async () => {
    const handle = CFG.designCollection || 'ready-to-press-designs', out = [];
    for (let page = 1; page <= 20; page++) {
      const r = await fetch(`/collections/${encodeURIComponent(handle)}/products.json?limit=250&page=${page}`);
      if (!r.ok) break;
      const list = (await r.json()).products || [];
      list.forEach(p => { const img = p.images?.[0]?.src; if (img) out.push({ handle: p.handle, title: p.title, img, text: clean([p.title, p.product_type, ...(Array.isArray(p.tags) ? p.tags : String(p.tags || '').split(','))].join(' ')) }); });
      if (list.length < 250) break;
    }
    return out;
  })().catch(e => { console.error('[tps] designs', e); allDesigns = null; return []; }));
  const sized = (src, w) => src.replace(/(\.[a-z0-9]+)(\?|$)/i, `_${w}x$1$2`);
  let searchTok = 0;
  $('[data-design-search]')?.addEventListener('input', async e => {
    const q = clean(e.target.value), tok = ++searchTok;
    if (!q) { lib.innerHTML = firstLib; return; }
    lib.innerHTML = '<p class="tps-muted">Searching…</p>';
    const words = q.split(' ');
    const hits = (await loadDesigns()).filter(d => words.every(w => d.text.includes(w) || d.text.includes(w.replace(/s$/, ''))));
    if (tok !== searchTok) return;
    lib.innerHTML = hits.length ? hits.slice(0, 120).map(d => `<button type="button" data-lib data-src="${esc(sized(d.img, 1200))}" data-name="${esc(d.title)}" data-handle="${esc(d.handle)}" title="${esc(d.title)}"><img src="${esc(sized(d.img, 240))}" alt="${esc(d.title)}" loading="lazy"><span>${esc(d.title)}</span></button>`).join('') + (hits.length > 120 ? `<p class="tps-muted">Showing 120 of ${hits.length}. Add another word to narrow it down.</p>` : '')
      : `<p class="tps-muted">No designs match “${esc(e.target.value)}”.</p>`;
  });

  /* names & numbers */
  fontOptions($('[data-nn-font]')); fontOptions($('[data-edit-font]'));
  const syncNN = () => {
    $('[data-nn-name]').checked = S.nn.name; $('[data-nn-number]').checked = S.nn.number;
    $('[data-nn-style]').hidden = !(S.nn.name || S.nn.number);
    $('[data-nn-font]').value = S.nn.font; $('[data-nn-color]').value = S.nn.color;
    $('[data-nn-name-price]').textContent = charge('Personalized name') ? `+${money(chargePrice('Personalized name'))} each` : '';
    $('[data-nn-number-price]').textContent = charge('Personalized number') ? `+${money(chargePrice('Personalized number'))} each` : '';
  };
  const ensureNN = () => {
    const back = S.layers.Back;
    if (S.nn.name && !back.some(l => l.type === 'nn-name')) back.push({ id: uid(), type: 'nn-name', x: 50, y: 16, w: 62, rot: 0 });
    if (S.nn.number && !back.some(l => l.type === 'nn-number')) back.push({ id: uid(), type: 'nn-number', x: 50, y: 50, w: 44, rot: 0 });
    if (S.nn.name || S.nn.number) { if (!S.roster.length) addRosterRow(); }
  };
  $('[data-nn-name]').addEventListener('change', e => { S.nn.name = e.target.checked; ensureNN(); setSide('Back'); syncNN(); commit(); });
  $('[data-nn-number]').addEventListener('change', e => { S.nn.number = e.target.checked; ensureNN(); setSide('Back'); syncNN(); commit(); });
  $('[data-nn-font]').addEventListener('change', e => { S.nn.font = e.target.value; renderLayers(); commit(); });
  $('[data-nn-color]').addEventListener('input', e => { S.nn.color = e.target.value; renderLayers(); });
  $('[data-nn-color]').addEventListener('change', commit);

  /* editor */
  const openEditor = () => {
    const [l] = findLayer(S.sel); if (!l) return;
    setTool('edit');
    const isText = l.type === 'text', isNN = l.type.startsWith('nn');
    $('[data-edit-kind]').textContent = isText ? 'Text editor' : isNN ? 'Names & numbers' : 'Artwork';
    $('[data-edit-title]').textContent = isText ? 'Edit text' : isNN ? (l.type === 'nn-name' ? 'Name placement' : 'Number placement') : (l.name || 'Artwork');
    $('[data-edit-text-fields]').hidden = !isText;
    $('[data-edit-image-fields]').hidden = l.type !== 'image';
    $$('[data-act="dup"],[data-act="del"],[data-act="flip"]').forEach(b => b.hidden = isNN);
    syncEditor();
  };
  const syncEditor = () => {
    const [l] = findLayer(S.sel); if (!l || S.tool !== 'edit') return;
    if (l.type === 'text') {
      $('[data-edit-text]').value = l.text; $('[data-edit-font]').value = l.font; $('[data-edit-color]').value = l.color;
      $('[data-edit-stroke]').value = l.stroke || '#ffffff'; $('[data-edit-stroke-w]').value = l.strokeW || 0; $('[data-edit-arc]').value = l.arc || 0;
    }
    if (l.type === 'image') {
      const q = $('[data-quality]'); const dpi = dpiFor(l);
      q.className = 'tps-quality ' + (dpi >= 200 ? 'is-good' : dpi < 150 ? 'is-bad' : '');
      q.textContent = l.natW ? `Print quality: ${dpi >= 200 ? 'Great' : dpi >= 150 ? 'OK' : 'Low'} (${dpi} DPI at ${(AREA_IN[S.side][0] * l.w / 100).toFixed(1)}" wide)` : 'Print quality will be checked by our team.';
    }
    $('[data-edit-size]').value = Math.round(l.w); $('[data-edit-rot]').value = l.rot || 0;
  };
  const editLayer = (fn, doCommit) => { const [l] = findLayer(S.sel); if (!l) return; fn(l); renderLayers(); syncEditor(); if (doCommit) commit(); };
  $('[data-edit-text]').addEventListener('input', e => editLayer(l => l.text = e.target.value || ' '));
  $('[data-edit-font]').addEventListener('change', e => { editLayer(l => l.font = e.target.value, true); document.fonts?.load(`${fontWeight(e.target.value)} 40px "${e.target.value}"`).then(renderLayers); });
  $('[data-edit-color]').addEventListener('input', e => editLayer(l => l.color = e.target.value));
  $('[data-edit-stroke]').addEventListener('input', e => editLayer(l => { l.stroke = e.target.value; if (!l.strokeW) l.strokeW = 3; }));
  $('[data-edit-stroke-w]').addEventListener('input', e => editLayer(l => l.strokeW = Number(e.target.value)));
  $('[data-edit-arc]').addEventListener('input', e => editLayer(l => l.arc = Number(e.target.value)));
  $('[data-edit-size]').addEventListener('input', e => editLayer(l => l.w = Number(e.target.value)));
  $('[data-edit-rot]').addEventListener('input', e => editLayer(l => l.rot = Number(e.target.value)));
  ['[data-edit-text]', '[data-edit-color]', '[data-edit-stroke]', '[data-edit-stroke-w]', '[data-edit-arc]', '[data-edit-size]', '[data-edit-rot]'].forEach(s => $(s).addEventListener('change', commit));
  $('[data-deselect]').addEventListener('click', () => select(null));
  $$('[data-act]').forEach(b => b.addEventListener('click', () => {
    const [l, side] = findLayer(S.sel); if (!l) return;
    const arr = S.layers[side], i = arr.indexOf(l);
    switch (b.dataset.act) {
      case 'center': l.x = 50; break;
      case 'flip': l.flip = !l.flip; break;
      case 'up': if (i < arr.length - 1) { arr.splice(i, 1); arr.splice(i + 1, 0, l); } break;
      case 'down': if (i > 0) { arr.splice(i, 1); arr.splice(i - 1, 0, l); } break;
      case 'dup': { const c = { ...l, id: uid(), x: clamp(l.x + 4, 0, 100), y: clamp(l.y + 4, 0, 100) }; arr.push(c); if (S.files[l.id]) S.files[c.id] = S.files[l.id]; S.sel = c.id; break; }
      case 'del': removeLayer(l.id); return;
    }
    renderLayers(); syncEditor(); commit();
  }));

  /* undo / redo / reset */
  $('[data-undo]').addEventListener('click', () => { if (!hist.past.length) return; hist.future.push(lastSnap); restore(hist.past.pop()); syncUndo(); });
  $('[data-redo]').addEventListener('click', () => { if (!hist.future.length) return; hist.past.push(lastSnap); restore(hist.future.pop()); syncUndo(); });
  $('[data-reset]').addEventListener('click', () => {
    if (!S.layers.Front.length && !S.layers.Back.length) return;
    S.layers = { Front: [], Back: [] }; S.nn.name = S.nn.number = false; S.roster = []; S.files = {}; S.sel = null;
    syncNN(); renderGarment(); commit(); toast('Design cleared. Use Undo to bring it back.');
  });

  /* thumbnails (front/back mini previews) */
  const miniBoard = (side, size) => {
    const url = garmentUrl(S.product, S.color, side) || products.find(p => p.handle === S.product)?.image || '';
    const a = AREA[side];
    const zw = 720 * a[2] / 100;
    const list = S.layers[side].filter(l => (l.type !== 'nn-name' || S.nn.name) && (l.type !== 'nn-number' || S.nn.number));
    const inner = `<div class="tps-thumb-inner" style="transform:scale(${size / 720})"><img src="${esc(url)}" style="position:absolute;inset:0;width:100%;height:100%;object-fit:contain" alt=""><div style="position:absolute;left:${a[0]}%;top:${a[1]}%;width:${a[2]}%;height:${a[3]}%">${list.map(l => `<div style="position:absolute;left:${l.x}%;top:${l.y}%;width:${l.w}%;transform:translate(-50%,-50%) rotate(${l.rot || 0}deg) scaleX(${l.flip ? -1 : 1});line-height:1">${layerHTML(l, zw)}</div>`).join('')}</div></div>`;
    return inner;
  };
  const renderThumbs = () => { $$('[data-thumb]').forEach(t => t.innerHTML = miniBoard(t.dataset.thumb, t.getBoundingClientRect().width || 74)); };

  /* ---------- quantities / roster ---------- */
  const hasFront = () => S.layers.Front.length > 0;
  const hasBackArt = () => S.layers.Back.some(l => !l.type.startsWith('nn'));
  const nnOn = () => S.nn.name || S.nn.number;
  /* Oct 2026: only print or list names/numbers the customer actually typed in, never the NAME / 00 placeholders */
  const nnReal = type => type === 'nn-name' ? !!(S.nn.name && S.roster.some(r => (r.name || '').trim())) : type === 'nn-number' ? !!(S.nn.number && S.roster.some(r => String(r.number || '').trim())) : true;
  const shirtLines = () => {
    // returns [{color,size,qty,names:[...]}]
    const map = new Map();
    if (nnOn()) {
      S.roster.forEach(r => { if (!r.size || !r.color) return; const k = r.color + '|' + r.size; if (!map.has(k)) map.set(k, { color: r.color, size: r.size, qty: 0, names: [] }); const m = map.get(k); m.qty++; const tag = [S.nn.name ? (r.name || '').trim() : '', S.nn.number && String(r.number || '').trim() ? '#' + String(r.number).trim() : ''].filter(Boolean).join(' '); if (tag) m.names.push(tag); });
    } else {
      S.colors.forEach(c => Object.entries(S.qty[c] || {}).forEach(([size, q]) => { q = Number(q) || 0; if (q > 0) map.set(c + '|' + size, { color: c, size, qty: q, names: [] }); }));
    }
    return [...map.values()];
  };
  const totalShirts = () => shirtLines().reduce((s, l) => s + l.qty, 0);
  const priceFor = (lines = shirtLines()) => {
    const n = lines.reduce((s, l) => s + l.qty, 0);
    const tier = tierFor(Math.max(n, 1))[2];
    const front = hasFront() ? chargePrice('Front print ' + tier) : 0;
    const back = hasBackArt() ? chargePrice(backTitle(tier)) : 0;
    let garmentTotal = 0, missing = [];
    lines.forEach(l => { const v = variantFor(l.color, l.size); if (!v || !v.available) missing.push(`${l.color} ${l.size}`); garmentTotal += (v?.price || 0) * l.qty; });
    const names = nnOn() && S.nn.name ? S.roster.filter(r => r.name?.trim()).length : 0;
    const numbers = nnOn() && S.nn.number ? S.roster.filter(r => String(r.number || '').trim()).length : 0;
    const nameP = chargePrice('Personalized name'), numP = chargePrice('Personalized number');
    const total = garmentTotal + n * (front + back) + names * nameP + numbers * numP;
    return { n, tier, front, back, garmentTotal, names, numbers, nameP, numP, total, each: n ? total / n : 0, missing };
  };
  const renderQty = () => {
    const sizes = sizesOf();
    $('[data-qty-grids]').hidden = nnOn();
    $('[data-roster]').hidden = !nnOn();
    if (!nnOn()) {
      $('[data-qty-grids]').innerHTML = S.colors.map(c => {
        const q = S.qty[c] || {};
        const count = Object.values(q).reduce((s, v) => s + (Number(v) || 0), 0);
        return `<div class="tps-grid-card"><header><i style="background:${colorHex(c)}"></i>${esc(products.find(p => p.handle === S.product)?.label || '')} · ${esc(c)}<span>${count} item${count === 1 ? '' : 's'}</span></header>
        <div class="tps-sizes">${sizes.map(s => { const v = variantFor(c, s); const out = !v || !v.available; return `<label class="${out ? 'is-out' : ''}">${esc(s)}<input type="number" min="0" inputmode="numeric" value="${q[s] || ''}" data-q-color="${esc(c)}" data-q-size="${esc(s)}" ${out ? 'disabled title="Out of stock"' : ''}><em>${v ? money(v.price) : '—'}</em></label>`; }).join('')}</div></div>`;
      }).join('');
      $$('[data-q-color]').forEach(i => i.addEventListener('input', () => {
        const c = i.dataset.qColor, s = i.dataset.qSize;
        S.qty[c] = S.qty[c] || {}; S.qty[c][s] = Math.max(0, parseInt(i.value, 10) || 0);
        const card = i.closest('.tps-grid-card'); const n = Object.values(S.qty[c]).reduce((a, b) => a + b, 0);
        card.querySelector('header span').textContent = `${n} item${n === 1 ? '' : 's'}`;
        renderTiers(); updateLive(); autosave();
      }));
    } else {
      /* keep every roster row on a color this shirt actually offers, so what the drop-down shows is what gets ordered */
      S.roster.forEach(r => { if (!S.colors.includes(r.color)) r.color = S.colors[0]; });
      $('[data-col-name]').hidden = !S.nn.name; $('[data-col-number]').hidden = !S.nn.number;
      $('[data-roster-rows]').innerHTML = S.roster.map((r, i) => `<tr data-row="${r.id}"><td>${i + 1}</td>
        <td ${S.nn.name ? '' : 'hidden'}><input class="tps-input" maxlength="16" value="${esc(r.name || '')}" data-r="name" placeholder="NAME"></td>
        <td ${S.nn.number ? '' : 'hidden'}><input class="tps-input" maxlength="3" inputmode="numeric" value="${esc(r.number || '')}" data-r="number" placeholder="00" style="width:64px"></td>
        <td><select data-r="color">${S.colors.map(c => `<option ${c === r.color ? 'selected' : ''}>${esc(c)}</option>`).join('')}</select></td>
        <td><select data-r="size"><option value="">Size</option>${sizes.map(s => `<option ${s === r.size ? 'selected' : ''}>${esc(s)}</option>`).join('')}</select></td>
        <td><button type="button" class="tps-rm" data-rm aria-label="Remove row">×</button></td></tr>`).join('');
      $$('[data-row]').forEach(tr => {
        const r = S.roster.find(x => x.id === tr.dataset.row);
        tr.querySelectorAll('[data-r]').forEach(inp => inp.addEventListener(inp.tagName === 'SELECT' ? 'change' : 'input', () => { r[inp.dataset.r] = inp.dataset.r === 'name' ? inp.value.toUpperCase() : inp.value; if (inp.dataset.r === 'name') inp.value = r.name; renderTiers(); updateLive(); autosave(); }));
        tr.querySelector('[data-rm]').addEventListener('click', () => { S.roster = S.roster.filter(x => x.id !== r.id); renderQty(); updateLive(); autosave(); });
      });
    }
    renderTiers();
    $('[data-mini-preview]').innerHTML = ['Front', 'Back'].map(side => `<div class="tps-proof"><div class="tps-proof-board">${miniBoard(side, 300)}</div>${side}</div>`).join('');
  };
  const addRosterRow = () => { S.roster.push({ id: uid(), name: '', number: '', color: S.color || S.colors[0], size: '' }); };
  $('[data-add-row]').addEventListener('click', () => { addRosterRow(); renderQty(); const rows = $$('[data-row]'); rows[rows.length - 1]?.querySelector('input')?.focus(); autosave(); });
  const renderTiers = () => {
    const p = priceFor(), n = p.n;
    const one = TIERS.map(t => {
      const tier = t[2];
      const printEach = (hasFront() ? chargePrice('Front print ' + tier) : 0) + (hasBackArt() ? chargePrice(backTitle(tier)) : 0);
      return `<tr class="${n && tierFor(n)[2] === tier ? 'is-on' : ''}"><td>${tier} shirts</td><td>${money(printEach)} per shirt for printing</td></tr>`;
    }).join('');
    $('[data-tiers]').innerHTML = hasCharges() ? `<table><caption>Print pricing drops as you order more${n ? ` · you have ${n}` : ''}</caption>${one}</table>` : '';
  };

  /* ---------- live price bar ---------- */
  const updateLive = () => {
    if (!hasCharges()) { $('[data-live-each]').textContent = '—'; $('[data-live-note]').textContent = 'Pricing unavailable'; return; }
    const lines = shirtLines();
    let p;
    if (lines.length) p = priceFor(lines);
    else {
      const s = sizesOf().find(x => x === 'L') || sizesOf()[0];
      p = priceFor([{ color: S.color, size: s, qty: 1, names: [] }]);
    }
    $('[data-live-each]').textContent = p.n ? money(p.each) : '—';
    const next = TIERS.find(t => t[0] > p.n);
    $('[data-live-note]').textContent = lines.length ? `${p.n} shirt${p.n === 1 ? '' : 's'} · ${money(p.total)} total${next && (hasFront() || hasBackArt()) ? ` · order ${next[0]}+ to save more` : ''}` : 'for 1 shirt';
  };
  $('[data-get-price]').addEventListener('click', () => {
    const s = sizesOf().find(x => x === 'L') || sizesOf()[0];
    const rows = [1, 6, 12, 24, 48].map(n => { const p = priceFor([{ color: S.color, size: s, qty: n, names: [] }]); return `<tr><td>${n} shirt${n > 1 ? 's' : ''}</td><td style="text-align:right"><b>${money(p.each)}</b> each</td><td style="text-align:right;color:#6b7178">${money(p.total)}</td></tr>`; }).join('');
    const where = [hasFront() && 'front', hasBackArt() && 'back'].filter(Boolean).join(' + ') || 'no print yet';
    modal(`<h3>Instant price</h3><p class="tps-sub">${esc(products.find(p => p.handle === S.product)?.label || '')} · ${esc(S.color)} · size ${esc(s)} · ${where}${nnOn() ? ' · plus names/numbers per shirt' : ''}. Shipping calculated at checkout; free local pickup in Burnet.</p><table style="width:100%;border-collapse:collapse;font-size:14px">${rows}</table><p class="tps-muted" style="margin-top:10px">2XL and up cost a little more. Enter your exact sizes in step 2 for your real total.</p><button type="button" class="tps-btn tps-btn-main tps-wide" data-modal-next style="margin-top:8px">Enter quantities →</button>`);
    $('[data-modal-next]').addEventListener('click', () => { closeModal(); goStep(2); });
  });

  /* ---------- steps ---------- */
  const goStep = n => {
    if (n > 1 && !S.layers.Front.length && !S.layers.Back.length) { toast('Add text, artwork or names to the shirt first.'); return; }
    if (n === 3) {
      const lines = shirtLines();
      if (!lines.length) { toast(nnOn() ? 'Add at least one shirt to the roster with a size.' : 'Enter at least one quantity.'); return; }
      if (nnOn() && S.roster.some(r => !r.size)) { toast('Every roster row needs a size.'); return; }
      const p = priceFor(lines);
      if (p.missing.length) { toast(`Not available: ${p.missing.join(', ')}`); return; }
    }
    S.step = n; select(null);
    $('[data-body]').hidden = n !== 1;
    $$('[data-step]').forEach(s => s.hidden = Number(s.dataset.step) !== n);
    $$('[data-step-tab]').forEach(t => { const k = Number(t.dataset.stepTab); t.classList.toggle('is-on', k === n); t.classList.toggle('is-done', k < n); });
    $('[data-next]').hidden = n === 3; $('[data-get-price]').hidden = n !== 1; $('[data-save]').hidden = n === 3;
    $('[data-next]').textContent = n === 2 ? 'Review order →' : 'Next step →';
    if (n === 2) renderQty();
    if (n === 3) renderReview();
    window.scrollTo({ top: root.getBoundingClientRect().top + window.scrollY - 10, behavior: 'smooth' });
  };
  $('[data-next]').addEventListener('click', () => goStep(S.step + 1));
  $('[data-calc]').addEventListener('click', () => goStep(3));
  $$('[data-to-step]').forEach(b => b.addEventListener('click', () => goStep(Number(b.dataset.toStep))));
  $$('[data-step-tab]').forEach(t => t.addEventListener('click', () => { const k = Number(t.dataset.stepTab); if (k < S.step || k === S.step + 1) goStep(k); }));

  /* ---------- review ---------- */
  /* customer-facing cart text: plain words only (full detail stays in the hidden _design property and the print files) */
  const summary = side => {
    const list = S.layers[side].filter(l => nnReal(l.type));
    if (!list.length) return '';
    return list.map(l =>
      l.type === 'text' ? `Text "${l.text.replace(/\n/g, ' / ')}" (${l.font}, ${l.color}${l.strokeW ? ', outline ' + l.stroke : ''}${l.arc ? ', arc ' + l.arc : ''})` :
      l.type === 'image' ? `Art: ${l.name || 'image'}` :
      l.type === 'nn-name' ? 'Player name' : 'Player number'
    ).join(' | ') + ` — ${Math.round(AREA_IN[side][0] * Math.max(...list.map(l => l.w)) / 100 * 10) / 10}" max width`;
  };
  const renderReview = () => {
    const lines = shirtLines(), p = priceFor(lines);
    $('[data-proofs]').innerHTML = ['Front', 'Back'].filter(s => S.layers[s].length).map(side => `<div class="tps-proof"><div class="tps-proof-board">${miniBoard(side, 300)}</div>${side}</div>`).join('');
    const label = products.find(x => x.handle === S.product)?.label || '';
    const rows = [];
    lines.forEach(l => { const v = variantFor(l.color, l.size); rows.push([`${label} · ${l.color} · ${l.size} × ${l.qty}`, (v?.price || 0) * l.qty]); });
    if (p.front) rows.push([`Front print · ${p.n} × ${money(p.front)} (${p.tier} tier)`, p.front * p.n]);
    if (p.back) rows.push([`${p.front ? 'Back print (second side)' : 'Back print'} · ${p.n} × ${money(p.back)} (${p.tier} tier)`, p.back * p.n]);
    if (p.names) rows.push([`Names · ${p.names} × ${money(p.nameP)}`, p.names * p.nameP]);
    if (p.numbers) rows.push([`Numbers · ${p.numbers} × ${money(p.numP)}`, p.numbers * p.numP]);
    $('[data-breakdown]').innerHTML = `<table>${rows.map(r => `<tr><td>${esc(r[0])}</td><td>${money(r[1])}</td></tr>`).join('')}<tr class="tps-total"><td>Total</td><td>${money(p.total)}</td></tr><tr class="tps-each"><td>Price per shirt</td><td>${money(p.each)}</td></tr></table>`;
    $('[data-approve]').checked = false; $('[data-add-cart]').disabled = true;
  };
  $('[data-approve]').addEventListener('change', e => $('[data-add-cart]').disabled = !e.target.checked || !hasCharges());

  /* ---------- proof rendering (print files) ---------- */
  const loadImg = src => new Promise((res, rej) => { const i = new Image(); if (!/^blob:|^data:/.test(src)) i.crossOrigin = 'anonymous'; i.onload = () => res(i); i.onerror = rej; i.src = src; });
  const renderProof = async side => {
    const list = S.layers[side].filter(l => nnReal(l.type));
    if (!list.length) return null;
    const [wIn, hIn] = AREA_IN[side], DPI = 150;
    const W = wIn * DPI, H = hIn * DPI;
    const c = document.createElement('canvas'); c.width = W; c.height = H;
    const ctx = c.getContext('2d');
    for (const l of list) {
      try {
        const pxW = W * l.w / 100;
        let img, h;
        if (l.type === 'image') { img = await loadImg(l.handle ? await cutFor(l.src) : l.src); h = pxW * (img.naturalHeight / img.naturalWidth); }
        else {
          const t = l.type === 'nn-name' ? { ...l, text: nnText('name'), font: S.nn.font, color: S.nn.color } : l.type === 'nn-number' ? { ...l, text: nnText('number'), font: S.nn.font, color: S.nn.color } : l;
          await document.fonts?.load(`${fontWeight(t.font)} 100px "${t.font}"`);
          // SVG-as-image cannot use web fonts, so draw the text straight onto the canvas
          ctx.save(); ctx.translate(W * l.x / 100, H * l.y / 100); ctx.rotate((l.rot || 0) * Math.PI / 180); if (l.flip) ctx.scale(-1, 1);
          const { lines, wide, lh } = textMetrics(t); const pad = (t.strokeW || 0) * 2 + 4; const k = pxW / (wide + pad * 2);
          ctx.scale(k, k); ctx.textAlign = 'center'; ctx.textBaseline = 'alphabetic';
          ctx.font = `${fontWeight(t.font)} 100px "${t.font}"`;
          const totalH = lines.length * lh + pad * 2; const top = -totalH / 2;
          lines.forEach((line, i) => { const y = top + pad + 85 + i * lh; if (t.strokeW) { ctx.lineJoin = 'round'; ctx.lineWidth = t.strokeW * 2; ctx.strokeStyle = t.stroke; ctx.strokeText(line, 0, y); } ctx.fillStyle = t.color; ctx.fillText(line, 0, y); });
          ctx.restore();
          continue;
        }
        ctx.save(); ctx.translate(W * l.x / 100, H * l.y / 100); ctx.rotate((l.rot || 0) * Math.PI / 180); if (l.flip) ctx.scale(-1, 1);
        ctx.drawImage(img, -pxW / 2, -h / 2, pxW, h); ctx.restore();
      } catch (e) { console.warn('[tps] proof layer skipped', e); }
    }
    return new Promise(res => { try { c.toBlob(b => res(b), 'image/png'); } catch (e) { res(null); } });
  };

  /* ---------- add to cart ---------- */
  $('[data-add-cart]').addEventListener('click', async () => {
    const btn = $('[data-add-cart]'), status = $('[data-status]');
    btn.disabled = true; status.textContent = 'Preparing your print files…';
    try {
      const lines = shirtLines(), p = priceFor(lines);
      if (!lines.length) throw new Error('No shirts in the order.');
      const designId = 'TP-' + Date.now().toString(36).toUpperCase().slice(-6);
      const notes = $('[data-notes]').value.trim();
      const shared = {
        'Design ID': designId,
        'Front': summary('Front') || 'None',
        'Back': summary('Back') || 'None'
      };
      if (notes) shared['Notes'] = notes;
      const designJson = JSON.stringify({ v: 6, product: S.product, colors: S.colors, nn: S.nn, layers: S.layers, area: AREA, areaIn: AREA_IN }, (k, v) => (k === 'src' && String(v).startsWith('blob:')) ? 'upload' : v);
      const items = lines.map(l => {
        const v = variantFor(l.color, l.size);
        const props = { ...shared };
        if (l.names.length) props['Names / Numbers'] = l.names.join(', ');
        return { id: v.id, quantity: l.qty, properties: props };
      });
      const extra = [];
      const chargeLine = (title, qty) => { const c = charge(title); if (c && qty > 0) extra.push({ id: c.id, quantity: qty, properties: { 'Design ID': designId } }); };
      if (p.front) chargeLine('Front print ' + p.tier, p.n);
      if (p.back) chargeLine(backTitle(p.tier), p.n);
      chargeLine('Personalized name', p.names);
      chargeLine('Personalized number', p.numbers);

      // first garment line carries the files (proofs + original uploads)
      const form = new FormData();
      form.append('id', items[0].id); form.append('quantity', items[0].quantity);
      Object.entries(items[0].properties).forEach(([k, v]) => form.append(`properties[${k}]`, v));
      form.append('properties[_design]', designJson.slice(0, 5000));
      for (const side of ['Front', 'Back']) { const blob = await renderProof(side); if (blob) form.append(`properties[${side} print file]`, new File([blob], `${designId}-${side.toLowerCase()}.png`, { type: 'image/png' })); }
      Object.entries(S.files).forEach(([id, file], i) => { if (findLayer(id)[0]) form.append(`properties[Artwork upload ${i + 1}]`, file, file.name); });
      status.textContent = 'Adding to cart…';
      const r1 = await fetch(`${CFG.cartAdd}.js`, { method: 'POST', headers: { Accept: 'application/json' }, body: form });
      if (!r1.ok) { const j = await r1.json().catch(() => ({})); throw new Error(j.description || 'The shirt could not be added.'); }
      const rest = [...items.slice(1), ...extra];
      if (rest.length) {
        const r2 = await fetch(`${CFG.cartAdd}.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: rest }) });
        if (!r2.ok) { const j = await r2.json().catch(() => ({})); throw new Error(j.description || 'Print charges could not be added.'); }
      }
      status.textContent = 'Added! Taking you to your cart…';
      try { localStorage.removeItem(SAVE_KEY); } catch (e) {}
      location.href = CFG.cart;
    } catch (e) {
      console.error('[tps] add to cart', e);
      status.textContent = `${e.message || 'Something went wrong.'} Please try again or call (830) 613-5096.`;
      btn.disabled = false;
    }
  });

  /* ---------- save / share / restore ---------- */
  const SAVE_KEY = 'tp-studio-v6';
  const serial = () => ({ v: 6, product: S.product, colors: S.colors, color: S.color, qty: S.qty, nn: S.nn, roster: S.roster, layers: S.layers });
  let saveTimer = 0;
  const autosave = () => { clearTimeout(saveTimer); saveTimer = setTimeout(() => { try { const o = serial(); o.layers = JSON.parse(JSON.stringify(o.layers, (k, v) => (k === 'src' && String(v).startsWith('blob:')) ? undefined : v)); o.layers.Front = o.layers.Front.filter(l => l.src || l.type !== 'image'); o.layers.Back = o.layers.Back.filter(l => l.src || l.type !== 'image'); localStorage.setItem(SAVE_KEY, JSON.stringify(o)); } catch (e) {} }, 400); };
  const toDataUrl = file => new Promise(res => { const r = new FileReader(); r.onload = () => res(r.result); r.onerror = () => res(null); r.readAsDataURL(file); });
  $('[data-save]').addEventListener('click', async () => {
    try {
      const o = serial();
      o.layers = JSON.parse(JSON.stringify(o.layers));
      for (const side of ['Front', 'Back']) for (const l of o.layers[side]) if (String(l.src || '').startsWith('blob:')) { const f = S.files[l.id]; l.src = f && f.size < 2.5e6 ? await toDataUrl(f) : undefined; }
      localStorage.setItem(SAVE_KEY, JSON.stringify(o));
      toast('Design saved on this device. It will be here when you come back.');
    } catch (e) { toast('Could not save — your browser storage may be full or blocked.'); }
  });
  $('[data-share]').addEventListener('click', async () => {
    const o = serial(); delete o.qty; delete o.roster;
    o.layers = JSON.parse(JSON.stringify(o.layers, (k, v) => (k === 'src' && /^(blob|data):/.test(String(v))) ? undefined : v));
    const skipped = ['Front', 'Back'].some(s => o.layers[s].some(l => l.type === 'image' && !l.src));
    o.layers.Front = o.layers.Front.filter(l => l.type !== 'image' || l.src); o.layers.Back = o.layers.Back.filter(l => l.type !== 'image' || l.src);
    const url = location.origin + location.pathname + '#d=' + btoa(unescape(encodeURIComponent(JSON.stringify(o))));
    try { await navigator.clipboard.writeText(url); toast(skipped ? 'Link copied. Uploaded images are not included in shared links.' : 'Share link copied to your clipboard.'); }
    catch (e) { modal(`<h3>Share your design</h3><p class="tps-sub">Copy this link:</p><textarea rows="4" readonly>${esc(url)}</textarea>`); }
  });
  const load = o => {
    if (!o || o.v !== 6) return false;
    S.colors = o.colors || []; S.color = o.color; S.qty = o.qty || {}; S.nn = { ...S.nn, ...(o.nn || {}) }; S.roster = o.roster || [];
    S.layers = { Front: (o.layers?.Front || []).filter(l => l.type !== 'image' || l.src), Back: (o.layers?.Back || []).filter(l => l.type !== 'image' || l.src) };
    return o.product;
  };

  /* ---------- modal ---------- */
  const modal = html => { $('[data-modal-body]').innerHTML = html; $('[data-modal]').hidden = false; };
  const closeModal = () => { $('[data-modal]').hidden = true; };
  $('[data-close-modal]').addEventListener('click', closeModal);
  $('[data-modal]').addEventListener('click', e => { if (e.target.matches('[data-modal]')) closeModal(); });

  /* ---------- render all / init ---------- */
  const renderAll = () => { syncNN(); renderGarment(); if (S.step === 2) renderQty(); };
  new ResizeObserver(() => renderLayers()).observe(zone);
  document.fonts?.ready.then(() => renderLayers());

  (async () => {
    if (!products.length) { $('[data-products]').innerHTML = '<p class="tps-muted">No shirts are set up in this studio yet.</p>'; return; }
    if (!hasCharges()) console.warn('[tps] custom-print-charges product missing — pricing disabled');
    const params = new URLSearchParams(location.search);
    let startProduct = null, keep = [];
    const hash = location.hash.match(/#d=(.+)$/);
    if (hash) { try { startProduct = load(JSON.parse(decodeURIComponent(escape(atob(hash[1]))))); keep = S.colors; history.replaceState(null, '', location.pathname + location.search); toast('Shared design loaded.'); } catch (e) {} }
    if (!startProduct) { try { const saved = JSON.parse(localStorage.getItem(SAVE_KEY) || 'null'); if (saved && (saved.layers?.Front?.length || saved.layers?.Back?.length)) { startProduct = load(saved); keep = S.colors; toast('Welcome back — your saved design is loaded.'); } } catch (e) {} }
    /* apparel-type picker (tp-studio-variants section): wait for the customer's choice */
    if (window.TPS_PICK && !hash) { try { const picked = await window.TPS_PICK; if (picked) startProduct = picked; } catch (e) {} }
    const wanted = params.get('product');
    if (wanted && products.some(p => p.handle === wanted)) startProduct = wanted;
    if (!products.some(p => p.handle === startProduct)) startProduct = products[0].handle;
    const cParam = params.get('color'); if (cParam) keep = [cParam, ...keep];
    await selectProduct(startProduct, keep);
    const dParam = params.get('design');
    if (dParam) {
      const btn = $$('[data-lib]').find(b => b.dataset.handle === dParam);
      if (btn) addLibrary(btn.dataset.src, btn.dataset.name, dParam);
      else { try { const d = await fetch(`/products/${encodeURIComponent(dParam)}.js`).then(r => r.ok ? r.json() : null); const src = d && (typeof d.featured_image === 'string' ? d.featured_image : d.featured_image?.src); if (src) addLibrary(src.startsWith('//') ? 'https:' + src : src, d.title, dParam); } catch (e) {} }
    }
    syncNN(); lastSnap = snapshot(); syncUndo(); updateLive(); renderGarment();
  })();
})();